import React, { useState, useEffect } from "react";
import { Form, Row, Col, Input, Select, Button } from "antd";
import { SearchOutlined, ReloadOutlined } from "@ant-design/icons";
import api from "../../../../api/enhancedApi";
import AircraftSelector from "../../../../components/common/AircraftSelector";
import AirportSelector from "../../../../components/common/AirportSelector";

const routeTypeOptions = [
    { value: "NORMAL", label: "正常航路" },
    { value: "EMERGENCY", label: "紧急航路" },
    { value: "WEATHER", label: "天气备用" },
    { value: "SEASONAL", label: "季节性航路" },
];

const FlightRouteFilter = ({ onFilter, onReset, initialValues = {} }) => {
    const [form] = Form.useForm();
    const [tags, setTags] = useState([]);

    useEffect(() => {
        loadTags();
    }, []);

    useEffect(() => {
        if (initialValues && Object.keys(initialValues).length > 0) {
            form.setFieldsValue(initialValues);
        }
    }, [initialValues, form]);

    const loadTags = async () => {
        try {
            const response = await api.flightRoute.getAllTags();
            setTags(response.data?.tags || []);
        } catch (error) {
            console.error("加载标签失败:", error);
        }
    };

    const handleSearch = () => {
        const values = form.getFieldsValue();

        const filterData = {
            ...values,
            aircraft_reg: values.aircraft_regs?.length ? values.aircraft_regs.join(",") : undefined,
        };

        delete filterData.aircraft_regs;

        Object.keys(filterData).forEach((key) => {
            if (filterData[key] === undefined || filterData[key] === null || filterData[key] === "") {
                delete filterData[key];
            }
        });

        onFilter(filterData);
    };

    const handleReset = () => {
        form.resetFields();
        onReset();
    };

    return (
        <Form form={form} layout="horizontal" onFinish={handleSearch} className="filter-form" labelAlign="right">
            <Row gutter={[16, 0]} align="middle">
                <Col flex="auto">
                    <Row gutter={[12, 8]}>
                        <Col>
                            <Form.Item label="航路名称" name="route_name" style={{ marginBottom: 0 }}>
                                <Input placeholder="模糊搜索" allowClear style={{ width: 130 }} />
                            </Form.Item>
                        </Col>
                        <Col>
                            <Form.Item label="出发" name="departure_airport" style={{ marginBottom: 0 }}>
                                <AirportSelector valueType="iata_code" placeholder="选择机场" allowClear style={{ width: 160 }} />
                            </Form.Item>
                        </Col>
                        <Col>
                            <Form.Item label="到达" name="arrival_airport" style={{ marginBottom: 0 }}>
                                <AirportSelector valueType="iata_code" placeholder="选择机场" allowClear style={{ width: 160 }} />
                            </Form.Item>
                        </Col>
                        <Col>
                            <Form.Item label="类型" name="route_type" style={{ marginBottom: 0 }}>
                                <Select placeholder="全部" allowClear options={routeTypeOptions} style={{ width: 110 }} />
                            </Form.Item>
                        </Col>
                        <Col>
                            <Form.Item label="状态" name="is_active" style={{ marginBottom: 0 }}>
                                <Select placeholder="全部" allowClear style={{ width: 80 }}>
                                    <Select.Option value={true}>启用</Select.Option>
                                    <Select.Option value={false}>停用</Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col>
                            <Form.Item label="默认" name="is_default" style={{ marginBottom: 0 }}>
                                <Select placeholder="全部" allowClear style={{ width: 80 }}>
                                    <Select.Option value={true}>是</Select.Option>
                                    <Select.Option value={false}>否</Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col>
                            <Form.Item label="适配飞机" name="aircraft_regs" style={{ marginBottom: 0 }}>
                                <AircraftSelector mode="multiple" placeholder="选择飞机" maxTagCount={1} maxTagTextLength={6} displayMode="simple" popupMatchSelectWidth={false} allowClear style={{ minWidth: 120 }} />
                            </Form.Item>
                        </Col>
                        {tags.length > 0 && (
                            <Col>
                                <Form.Item label="标签" name="tag" style={{ marginBottom: 0 }}>
                                    <Select placeholder="全部" allowClear style={{ width: 110 }}>
                                        {tags.map((tag) => (
                                            <Select.Option key={tag} value={tag}>
                                                {tag}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        )}
                    </Row>
                </Col>
                <Col flex="none">
                    <Form.Item style={{ marginBottom: 0 }}>
                        <Button type="primary" htmlType="submit" icon={<SearchOutlined />} style={{ marginRight: 8 }}>
                            搜索
                        </Button>
                        <Button icon={<ReloadOutlined />} onClick={handleReset}>
                            重置
                        </Button>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
};

export default FlightRouteFilter;
